import { createReducer, on } from '@ngrx/store';
import * as StopDestinationActions from '../actions/stop-destination.actions';
import {Destination} from '../../../services/api/destinations/destination.model';

export const stopDestinationFeatureKey = 'stopDestination';

export interface State {
  record: Destination | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(StopDestinationActions.stopDestination, (state) => ({
    ...state,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(StopDestinationActions.stopDestinationSuccess, (state, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(StopDestinationActions.stopDestinationFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(StopDestinationActions.clearStopDestinationState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

